/*
 * Copyright (c) 2026 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { TaskListWithSolutionBaseDtoModel } from './task-list-with-solution-dto.model';

export class TaskListWithSolutionFromHubDtoModel extends TaskListWithSolutionBaseDtoModel {
  routedOrderTemplateDraftUuids: string[] | undefined = undefined;
}
